import { render, staticRenderFns } from "./TabPopup.vue?vue&type=template&id=5f74433e&scoped=true"
import script from "./TabPopup.vue?vue&type=script&lang=js"
export * from "./TabPopup.vue?vue&type=script&lang=js"
import style0 from "./TabPopup.vue?vue&type=style&index=0&id=5f74433e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f74433e",
  null
  
)

export default component.exports